import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/services/common-services/common.service';
import { CartService } from 'src/app/services/cart.service';
@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.scss']
})
export class ThankYouComponent {
  companyId = sessionStorage.getItem('customercompanyId');
  portalUrl: string = environment.PORTAL_URL;
  baseUrl = environment.BASE_URL
  constructor(private router:Router, private commonServices:CommonService, private cartService:CartService){  }
  ngOnInit() {
      this.getCartProducts();
  }
  continueToShop(): void {
    //window.open(`${this.portalUrl}`, '_blank');
    this.router.navigateByUrl('/rfq');
  }
  getCartProducts() {
    let cartApi = `${this.baseUrl}rfq/cart/getCartItem?companyId=${this.companyId}`;
    this.commonServices.getData(cartApi).subscribe((data) => {
      //this.cartItems = data?.response;
      this.cartService.getCartItems(Number(this.companyId));
    });
  }
}
